export default {
  total: "Total",
  paid: "Pagado",
  unpaid: "No pagado",
  editor: "Editor",
  viewer: "Invitado",
  view: "Ver",
  save: "Guardar",
  cancel: "Cancelar",
  delete: "Eliminar",
  edit: "Editar",
  add: "Añadir",
  close: "Cerrar",
  confirm: "Confirmar",
  yes: "Sí",
  no: "No",
  loading: "Cargando...",
  error: "Error",
  success: "Éxito",
  warning: "Advertencia",
  info: "Información",
  search: "Buscar",
  filter: "Filtrar",
  sort: "Ordenar",
  export: "Exportar",
  import: "Importar",
  download: "Descargar",
  upload: "Subir",
  print: "Imprimir",
  share: "Compartir",
  copy: "Copiar",
  paste: "Pegar",
  cut: "Cortar",
  undo: "Deshacer",
  redo: "Rehacer",
  refresh: "Actualizar",
  back: "Atrás",
  next: "Siguiente",
  previous: "Anterior",
  first: "Primero",
  last: "Último",
  all: "Todos",
  none: "Ninguno",
  select: "Seleccionar",
  deselect: "Deseleccionar",
  clear: "Limpiar",
  reset: "Restablecer",
  apply: "Aplicar",
  submit: "Enviar",
  send: "Enviar",
  receive: "Recibir",
  create: "Crear",
  update: "Actualizar",
  remove: "Eliminar",
  duplicate: "Duplicar",
  move: "Mover",
  details: "Detalles",
  actions: {
    _self: "Acciones",
    add: "Añadir",
    addLong: "Añadir nuevo elemento",
    importGuests: "Importar invitados",
    share: "Compartir",
    useExample: "Usar ejemplo",
    addEvent: "Añadir evento",
    addExamples: "Añadir ejemplos",
    addingExamples: "Añadiendo ejemplos...",
    edit: "Editar",
    delete: "Eliminar",
    cancel: "Cancelar",
    save: "Guardar"
  },
  noResults: "No se encontraron resultados",
  pagination: {
    showing: "Mostrando {{from}} a {{to}} de {{total}} elementos"
  },
  time: "Tiempo",
  title: "Título",
  category: "Categoría",
  description: "Descripción",
  continue: "Continuar",
  required: "Requerido",
  optional: "Opcional",
  or: "o",
  and: "y",
  selectAll: "Seleccionar todo",
  deselectAll: "Deseleccionar todo",
  content: "Contenido",
  today: "Hoy",
  yesterday: "Ayer",
  saving: "Guardando...",
  viewAll: "Ver todo",
  more: "Más",
  less: "Menos",
  show: "Mostrar",
  hide: "Ocultar",
  errors: {
    generic: "Ocurrió un error",
    network: "Error de red",
    unauthorized: "Acceso no autorizado",
    notFound: "Recurso no encontrado",
    serverError: "Error del servidor",
    tryAgain: "Intentar de nuevo",
    goBack: "Volver",
    reload: "Recargar página",
    submit: "Error al enviar",
    loadGuests: "Error cargando invitados",
    updateGuest: "Error actualizando invitado",
    socialLoginFailed: "Inicio de sesión social fallido",
    userOrWeddingNotFound: "Usuario o boda no encontrado",
    googleSignIn: "Error de inicio de sesión con Google",
    loadVendors: "Error cargando proveedores",
    addVendor: "Error añadiendo proveedor",
    updateVendor: "Error actualizando proveedor",
    deleteVendor: "Error eliminando proveedor",
    saveSeatingPlan: "Error guardando plan de mesa",
    generateSeatingPlan: "Error generando plan de mesa"
  },
  disconnect: "Desconectar",
  sending: "Enviando...",
  verified: "Verificado",
  importGuests: "Importar invitados",
  status: {
    to_contact: "Por Contactar",
    contacted: "Contactado",
    meeting_scheduled: "Reunión Programada",
    quote_received: "Presupuesto Recibido",
    hired: "Contratado",
    deposit_paid: "Depósito Pagado",
    completed: "Completado",
    cancelled: "Cancelado",
    pending: "Pendiente",
    confirmed: "Confirmado",
    declined: "Rechazado",
    accepted: "Aceptado",
    inProgress: "En progreso",
    paid: "Pagado",
    unpaid: "No pagado",
    overdue: "Vencido",
    scheduled: "Programado",
    done: "Hecho",
    todo: "Por hacer",
    researching: "Investigando"
  },
  categories: {
    other: "Otro",
    venue: "Lugar",
    catering: "Catering",
    photography: "Fotografía",
    music: "Música",
    decoration: "Decoración",
    flowers: "Flores",
    attire: "Vestuario",
    jewelry: "Joyas",
    transport: "Transporte",
    lodging: "Alojamiento",
    ceremony: "Ceremonia",
    reception: "Recepción",
    videography: "Videografía",
    florist: "Florista",
    cake: "Pastel",
    dress: "Vestido",
    suit: "Traje",
    hair_makeup: "Maquillaje y Peinado",
    beauty: "Belleza"
  },
  pwa: {
    offlineReady: "App lista para usar sin conexión",
    newContent: "Nuevo contenido disponible, haz clic para actualizar.",
    reload: "Recargar"
  },
  validation: {
    required: {
      firstName: "El nombre es obligatorio",
      lastName: "El apellido es obligatorio",
      email: "El email es obligatorio"
    },
    invalid: {
      email: "El email es inválido"
    }
  },
  empty: {
    title: "Sin datos",
    description: "Nada que mostrar por ahora."
  },
  columns: {
    name: "Nombre",
    status: "Estado",
    category: "Categoría",
    actions: "Acciones",
    plusOne: "+1",
    children: "Niños"
  },
  confirmDialog: {
    delete: "¿Estás seguro de que quieres eliminar este elemento?",
    budgetRemoval: {
      title: "Eliminar presupuesto",
      message: "¿Realmente quieres eliminar este presupuesto?",
      confirm: "Eliminar",
      cancel: "Cancelar"
    }
  },
  deleteConfirmation: {
    title: "Eliminar",
    description: "Esta acción es irreversible.",
    confirmTitle: "Confirmar eliminación",
    confirmDescription: "¿Estás seguro de que quieres eliminar este elemento?",
    confirmButton: "Eliminar"
  },
  sortOptions: {
    title: "Ordenar por"
  },
  sharing: {
    title: "Compartir",
    share: "Compartir",
    accessLevel: "Nivel de Acceso",
    accessCode: "Código de Acceso",
    readOnly: "Solo Lectura",
    edit: "Editar",
    copy: "Copiar Enlace",
    copied: "¡Enlace copiado!",
    emailPlaceholder: "ejemplo@email.com",
    namePlaceholder: "Nombre del Destinatario",
    messagePlaceholder: "Añadir un mensaje personal...",
    recipientEmail: "Email del Destinatario",
    recipientName: "Nombre del Destinatario",
    message: "Mensaje",
    defaultMessage: "¡Te invito a colaborar en mi boda!",
    invitationCreated: "Invitación creada exitosamente",
    success: "Compartido exitosamente"
  },
  upgrade: "Mejorar",
  currentEvent: "Evento actual"
};
